export const faqItems = [
  {
    q: 'How long do the bars stay fresh?',
    // TODO: confirm with the sealed-bar shelf-life test before launch.
    a: 'Best within 2 weeks at room temperature. Refrigerated, they keep for up to 2 months. No preservatives means freshness depends on storage conditions.',
  },
  {
    q: 'Do the bars contain gluten?',
    a: 'Our bars are made with no gluten-containing ingredients. They are produced in a home kitchen and are not tested or certified gluten free.',
  },
  {
    q: 'Are these bars vegan?',
    a: 'No. Every Royal T bar contains raw honey and royal jelly, which are bee products.',
  },
  {
    q: 'Who should avoid royal jelly?',
    a: 'Royal jelly can cause allergic reactions, which can be serious in people with asthma or allergies to bees, honey or pollen. If that applies to you, check with your doctor before trying our bars.',
  },
  {
    q: 'Which allergens do the bars contain?',
    a: 'Every bar contains tree nuts: almonds in Red, Brazil nuts in Purple and cashews in Orange. All are made in a home kitchen that may also process other common food allergens.',
  },
  {
    q: 'Where are the bars made?',
    a: 'Handcrafted in a home kitchen in Chicago, IL, under the Illinois Cottage Food Law.',
  },
  {
    q: 'Do you ship outside Illinois?',
    a: 'Not yet. Under the Illinois Cottage Food Law we can only sell within Illinois. Join the waitlist and we will let you know when we can ship to you.',
  },
  {
    q: 'What does the registration number mean?',
    a: 'Under Illinois Cottage Food Law, all home-produced food products require a county registration number. Ours is issued by Cook County.',
  },
];
